<template>
  <!-- *RPD MHOR  Appv 0.91
* Copyright (c) 2025, Blue Cover Six LLC . John Molt. SAll rights reserved.
Code licensed under contract To Reno Police Department / City of Reno, in perpetuity -->
  <v-menu
    dark
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        dark
        color="white"
        :value="displayDate"
        :label="label"
        prepend-icon="$calendar"
        prepend-icon-color="white"
        readonly
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>

    <v-date-picker
      :prev-icon="'$arrowLeft'"
      :next-icon="'$arrowRight'"
      dark
      color="grey darken-1"
      v-model="selected"
      @input="updateDate"
      scrollable
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: "date_field",
  props: {
    value: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: "Select Date",
    },
  },
  data() {
    return {
      menu: false,
      selected: this.value || this.getToday(),
    };
  },
  computed: {
    displayDate() {
      if (!this.selected) return "";
      const [y, m, d] = this.selected.split("-");
      return `${m}/${d}/${y}`;
    },
  },
  watch: {
 value(newVal) {
    this.selected = newVal || this.getToday();
  },
  },
methods: {
    getToday() {
      const d = new Date();
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd}`;
    },

    updateDate(val) {
      this.selected = val;
      this.$emit("input", val);
      this.menu = false;
    },
  },
};
</script>